import React from 'react';
import { Form } from 'react-bootstrap';

// Shared by CreateApplicationSection3 (create wizard) and
// ApplicationDetailPage (revision-edit flow) so the contract wording and
// checkbox behavior can't drift between the two — they used to be hand-
// duplicated and the wording already changed once while only one copy got
// updated. The wording itself now comes from the LA program's config
// (GET /program/la/requirements), not from this file (#404).

// idPrefix keeps DOM ids unique per caller (create wizard vs. detail page)
// in case both ever end up in the same tree.
function LAContractAcknowledgment({
    acknowledgesContract,
    onChange,
    idPrefix,
    commitments = [],
    // true until the LA requirements load; LACommitmentCards shows why.
    // Nobody should acknowledge a contract they can't see.
    unavailable = false,
    isInvalid = false,
}) {
    const errorId = `${idPrefix}-acknowledges-la-contract-error`;

    return (
        <>
            <p className="text-muted mb-3">
                As the faculty mentor for this Learning Assistant, I understand
                and agree that:
            </p>
            {!unavailable && (
                <ul className="mb-3">
                    {commitments.map((term, i) => (
                        <li key={`${i}-${term}`}>{term}</li>
                    ))}
                </ul>
            )}
            <Form.Check
                type="checkbox"
                id={`${idPrefix}-acknowledges-la-contract`}
                label={
                    <>
                        I acknowledge and will adhere to the above contract
                        requirements. <span className="text-danger">*</span>
                    </>
                }
                checked={!unavailable && acknowledgesContract === true}
                onChange={(e) => onChange(e.target.checked)}
                disabled={unavailable}
                isInvalid={isInvalid}
                aria-invalid={isInvalid}
                aria-describedby={isInvalid ? errorId : undefined}
            />
            {isInvalid && (
                <Form.Control.Feedback
                    type="invalid"
                    id={errorId}
                    role="alert"
                    className="d-block"
                >
                    Acknowledgment is required.
                </Form.Control.Feedback>
            )}
        </>
    );
}

export default LAContractAcknowledgment;
